export const billingClosureState = (period, section) => {
  const invoiceOnly = ['forfait_consulenza', 'forfait_f24', 'import_file'].includes(section);
  const adempimenti = section === 'altri_adempimenti' || invoiceOnly;
  const bpointInvoiceClosed = Boolean(adempimenti
    ? period?.bpoint_adempimenti_invoice_closed : period?.bpoint_invoice_closed);
  const ziInvoiceClosed = period?.stato === 'chiuso';
  const bpointClosed = bpointInvoiceClosed || !invoiceOnly && Boolean(adempimenti ? period?.chiuso_sez3_bpoint : period?.chiuso_sez0);
  const ziClosed = ziInvoiceClosed || !invoiceOnly && (adempimenti ? Boolean(period?.chiuso_sez3)
    : Boolean(period?.chiuso_sez1 && period?.chiuso_sez2));
  return { bpointClosed, ziClosed, bpointInvoiceClosed, ziInvoiceClosed };
};
